var map = {
	"./babel": 7,
	"./babel.jpg": 7,
	"./bw-logo": 8,
	"./bw-logo.png": 8,
	"./home-logo": 9,
	"./home-logo.png": 9,
	"./m-logo": 10,
	"./m-logo.png": 10,
	"./qr-t": 11,
	"./qr-t.png": 11,
	"./qr-wb1": 12,
	"./qr-wb1.png": 12,
	"./qr-wb2": 13,
	"./qr-wb2.png": 13,
	"./qr-wx": 14,
	"./qr-wx.png": 14,
	"./share-arrow": 15,
	"./share-arrow.png": 15,
	"./slides/and_we": 16,
	"./slides/and_we.jpg": 16,
	"./slides/babel1": 17,
	"./slides/babel1.jpg": 17,
	"./slides/babel2": 18,
	"./slides/babel2.jpg": 18,
	"./slides/coliseum": 19,
	"./slides/coliseum.jpg": 19,
	"./slides/girl_reading": 20,
	"./slides/girl_reading.jpg": 20,
	"./slides/gravelines": 21,
	"./slides/gravelines.jpg": 21,
	"./slides/long_leg": 22,
	"./slides/long_leg.jpg": 22,
	"./slides/poor_poet": 23,
	"./slides/poor_poet.jpg": 23,
	"./slides/sorciere": 24,
	"./slides/sorciere.jpg": 24,
	"./slides/temma_bridge": 25,
	"./slides/temma_bridge.jpg": 25,
	"./t-logo": 26,
	"./t-logo.png": 26
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 29;